/**
 * The local tax routes the Location form, the site page and the Sales tax
 * page's Local rates part read (decisions 0737, 0739, 1020). 🔨 Relative to
 * the API root, never starting with `/api` again,
 * and registered in the declared map beside every other path.
 */
/** A site's Tax Jurisdiction: the rows its address resolves to today, the coverage, the warnings and the forms. */
export function siteJurisdictionPath(siteId: string): string {
  return `/tax/sites/${encodeURIComponent(siteId)}/jurisdiction`;
}

/** Confirm jurisdiction, a person's word that the lookup is the whole answer in a Partial state. */
export function siteJurisdictionConfirmPath(siteId: string): string {
  return `${siteJurisdictionPath(siteId)}/confirm`;
}

/** Decision 1020: the Sales tax page's Local rates part — a state's local jurisdictions with their series, and the two writes. */
export const LOCAL_JURISDICTIONS_PATH = '/tax/local-jurisdictions';

/** A state's local jurisdictions, each with its rate in force, its next scheduled rate and its folded history. */
export function localJurisdictionsPath(stateCode: string): string {
  return `${LOCAL_JURISDICTIONS_PATH}?stateCode=${encodeURIComponent(stateCode)}`;
}

/** + Add rate on one local jurisdiction, which supersedes the row in force on its day. */
export function localJurisdictionRatesPath(jurisdictionId: string): string {
  return `${LOCAL_JURISDICTIONS_PATH}/${encodeURIComponent(jurisdictionId)}/rates`;
}
